import React from 'react';
import './PlaceholderPanelCard.styles.scss'; // Assuming you've converted the styles to CSS

const PlaceholderPanelCard = () => {
    return <div className="placeholder-panel-card"></div>;
};

export default PlaceholderPanelCard;